import { render, staticRenderFns } from "./MemberCoursePermissionManagement.vue?vue&type=template&id=1f5909fb"
import script from "./MemberCoursePermissionManagement.vue?vue&type=script&lang=js"
export * from "./MemberCoursePermissionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports